import { useNavigate, useRouter } from '@tanstack/react-router'
import type { NotFoundRouteProps } from '@tanstack/react-router'

type NotFoundProps = NotFoundRouteProps

function NotFound(_props: NotFoundProps) {
  const navigate = useNavigate()
  const router = useRouter()

  const handleBack = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (router.history.canGoBack()) {
      return router.history.back()
    }
    navigate({ to: '/' })
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-4 text-center">
      <h1 className="text-3xl font-bold">404 - Page Not Found</h1>
      <p className="text-lg text-gray-600">
        The page you are looking for does not exist.
      </p>
      <button
        onClick={handleBack}
        className="rounded bg-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-600"
      >
        Go Back
      </button>
    </div>
  )
}

export default NotFound
